import type { MouseEvent } from 'react';

/**
 * Helper to check if mouse position should trigger hover state on header cell.
 * Only updates state when the hover state would change to avoid unnecessary re-renders.
 */
export const handleHeaderMouseMove = (
	e: MouseEvent<HTMLElement>,
	isHoveringCell: boolean,
	setHoveringCell: (hovering: boolean) => void,
): void => {
	const headerElement = e.currentTarget as HTMLElement;
	const headerRect = headerElement.getBoundingClientRect();
	const mouseY = e.clientY;

	// Mouse is in extended area if it's beyond the cell bounds
	const isInExtendedArea = mouseY < headerRect.top || mouseY > headerRect.bottom;
	const shouldShowHover = !isInExtendedArea;

	// Only update state if it needs to change
	if (shouldShowHover !== isHoveringCell) {
		setHoveringCell(shouldShowHover);
	}
};
